"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const modal_1 = __importDefault(require("antd/lib/modal"));
const useGetGerudoContainer_1 = require("../hooks/useGetGerudoContainer");
const NewModal_1 = require("./NewModal");
const LegacyModal_1 = require("./LegacyModal/LegacyModal");
/** Please use the most recent version of the Modal, for now using "isNewModal" prop. Deprecated props have been updated ^_^ */
const Modal = (_a) => {
    var { closable = true, wrapClassName, "data-testid": dataTestId = "gerudo-modal-test", isNewModal } = _a, props = __rest(_a, ["closable", "wrapClassName", "data-testid", "isNewModal"]);
    const { ref: modalRef, getGerudoContainer } = (0, useGetGerudoContainer_1.useGetGerudoContainer)();
    wrapClassName = (0, classnames_1.default)("gerudo-modal", wrapClassName);
    return (react_1.default.createElement("div", { className: "gerudo-modal-root", ref: modalRef }, isNewModal ? (react_1.default.createElement(NewModal_1.NewModal, Object.assign({ "data-testid": dataTestId, closable: closable, wrapClassName: wrapClassName }, props))) : (react_1.default.createElement(LegacyModal_1.LegacyModal, Object.assign({ "data-testid": dataTestId, closable: closable, wrapClassName: wrapClassName, getGerudoContainer: getGerudoContainer }, props)))));
};
exports.Modal = Modal;
Modal.confirm = modal_1.default.confirm;
exports.default = Modal;
//# sourceMappingURL=Modal.js.map